import { useContext } from 'react'
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import { Link } from 'react-router-dom'
import { steps } from 'layouts/onboarding'
import { IntakeContext } from 'context/IntakeContext'

export const MissingOnboardingSteps = () => {
  const { intakeState } = useContext(IntakeContext)
  return steps
    .filter(
      (step) =>
        step.type === 'Question' &&
        !intakeState[step.props?.id] &&
        (step?.dependencies || []).every(
          ({ attribute, value }) => intakeState[attribute] === value
        )
    )
    .map(({ id, props: { label } }) => {
      return (
        <Grid item xs={12}>
          <Card>
            <SoftBox px={3} py={2}>
              <SoftTypography
                textAlign="left"
                variant="h6"
                component="div"
                color="dark"
                fontWeight="bold"
              >
                Finish onboarding step
              </SoftTypography>
              <SoftTypography
                textAlign="left"
                color="text.secondary"
                variant="body2"
              >
                Revisit your onboarding steps and make sure you provide data
                for:
                <Link to={`/onboarding-full?onboardingStep=${id}`}>
                  {' '}
                  {label}
                </Link>
              </SoftTypography>
            </SoftBox>
          </Card>
        </Grid>
      )
    })
}
